import { z } from 'zod';
import { InputRegexMap, OnboardingFormFields } from '@Types/index.ts';
import { t } from 'i18next';

export const phoneFormScheme = z.object({
  [OnboardingFormFields.PHONE_NUMBER]: z
    .string()
    .trim()
    .min(1, t('enErrors:phoneRequired'))
    .regex(InputRegexMap.phoneUS, t('enErrors:phone')),
});
